import * as React from "react";
import { useSelector } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export default function ActionAreaCard() {
  const { sonviObject } = useSelector((state) => state.sonvi);
  const { lat, lng, category, comment, date, tags } = sonviObject;
  var options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric",
    day: "numeric",
  };
  return (
    <Card sx={{ width: "80%", margin: "5% auto" }}>
      <CardActionArea>
        <CardMedia
          component="img"
          // height="140"
          image={sonviObject.imageUrl}
          alt="green iguana"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {`Categoría: ${category}`}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {` Este sonvi fue creado en la posición de longitud y latitud : ${parseFloat(
              lat
            ).toFixed(3)}, ${parseFloat(lng).toFixed(3)}.`}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {`Etiquetas: ${tags} `}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {`Comentario del autor: ${comment} `}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {`Creado: ${new Date(date.seconds * 1000).toLocaleDateString(
              "es-MX",
              options
            )}`}
          </Typography>
          <br />
          <audio
            style={{ width: "100%" }}
            controls
            src={sonviObject.audioUrl}
          ></audio>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
